var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getProgram } from "./getProgram.obj";
import { isConfirmedTx } from "./isConfirmedTx.function";
import { sendSingleBundleTransaction } from "./sendSingleTransaction.function";
import { checkOptionSend } from "./check";
import { addPriorityFee } from "./fees";
import { isVersionedTransaction } from "@solana/wallet-adapter-base";
export function sendBundledTransactions(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var cOptionSend, clusterOrUrl, skipSimulation, connection, txsWithoutSigners, signer, skipConfirmation, provider, txsWithSigners, transactionHashs, confirmArray_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cOptionSend = checkOptionSend(Data);
                    clusterOrUrl = cOptionSend.clusterOrUrl, skipSimulation = cOptionSend.skipSimulation, connection = cOptionSend.connection;
                    txsWithoutSigners = Data.txsWithoutSigners, signer = Data.signer, skipConfirmation = Data.skipConfirmation;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, getProgram({
                            clusterOrUrl: clusterOrUrl,
                            signer: signer,
                        })];
                case 2:
                    provider = (_a.sent()).provider;
                    txsWithSigners = txsWithoutSigners.map(function (txWithSigners) {
                        txWithSigners.signers = [signer];
                        return txWithSigners;
                    });
                    console.log("User ", signer.publicKey.toBase58(), " has found to have ", txsWithoutSigners.length, " transaction(s) to send \nBroadcasting to blockchain ...");
                    if (!provider.sendAll)
                        throw { message: "your provider is not an AnchorProvider type" };
                    return [4 /*yield*/, provider.sendAll(txsWithSigners, {
                            maxRetries: 5,
                            skipPreflight: skipSimulation,
                        })];
                case 3:
                    transactionHashs = _a.sent();
                    if (!!skipConfirmation) return [3 /*break*/, 5];
                    return [4 /*yield*/, isConfirmedTx({
                            clusterOrUrl: clusterOrUrl,
                            transactionHashs: transactionHashs,
                            connection: connection,
                        })];
                case 4:
                    confirmArray_1 = _a.sent();
                    confirmArray_1.forEach(function (confirmTx) {
                        console.log("validating ", confirmTx.transactionHash, " ...");
                        if (!confirmTx.isConfirmed)
                            throw {
                                blockchain: "solana",
                                status: "error",
                                message: "some transaction were not confirmed ".concat(confirmArray_1.toString()),
                            };
                    });
                    _a.label = 5;
                case 5: return [2 /*return*/, transactionHashs];
                case 6:
                    error_1 = _a.sent();
                    throw error_1;
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function sendBundledTransactionsV2(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var cOptionSend, prioritizationFee, connection, bundleTransactions, signer, recentBlockhash, tempSigner_1, processedBTs, i, bt, error_2;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cOptionSend = checkOptionSend(Data);
                    prioritizationFee = cOptionSend.prioritizationFee, connection = cOptionSend.connection;
                    bundleTransactions = Data.bundleTransactions, signer = Data.signer;
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 1:
                    recentBlockhash = (_a.sent()).blockhash;
                    if (!signer)
                        bundleTransactions.map(function (tx) {
                            tx.stx.signatures.forEach(function (sig, i) {
                                if (sig.toLocaleString().length === 0)
                                    throw {
                                        blockchain: "solana",
                                        status: "error",
                                        message: "signer is required for unsigned Tx",
                                    };
                            });
                        });
                    else {
                        tempSigner_1 = signer;
                        bundleTransactions.forEach(function (BT) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!isVersionedTransaction(BT.tx)) return [3 /*break*/, 1];
                                        if (prioritizationFee)
                                            console.warn("prioritizationFee is not supported for VersionedTransaction");
                                        BT.tx.message.recentBlockhash = recentBlockhash;
                                        BT.stx = BT.tx;
                                        BT.stx.sign([tempSigner_1]);
                                        return [3 /*break*/, 4];
                                    case 1:
                                        if (!prioritizationFee) return [3 /*break*/, 3];
                                        _a = BT;
                                        return [4 /*yield*/, addPriorityFee(BT.tx, prioritizationFee)];
                                    case 2:
                                        _a.tx = _b.sent();
                                        _b.label = 3;
                                    case 3:
                                        BT.tx.feePayer = tempSigner_1.publicKey;
                                        BT.tx.recentBlockhash = recentBlockhash;
                                        BT.stx = BT.tx;
                                        BT.stx.sign(tempSigner_1);
                                        _b.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    console.log("User ", signer ? signer.publicKey.toBase58() : "- unknown signer -", " has found to have ", bundleTransactions.length, " transaction(s) to send \nBroadcasting to blockchain ...");
                    processedBTs = [];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 8, , 9]);
                    i = 0;
                    _a.label = 3;
                case 3:
                    if (!(i < bundleTransactions.length)) return [3 /*break*/, 7];
                    return [4 /*yield*/, sendSingleBundleTransaction(__assign({ bt: bundleTransactions[i] }, cOptionSend))];
                case 4:
                    bt = _a.sent();
                    processedBTs.push(bt);
                    return [4 /*yield*/, isConfirmedTx({ transactionHashs: [bt.hash], connection: connection })];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    i++;
                    return [3 /*break*/, 3];
                case 7: return [2 /*return*/, processedBTs];
                case 8:
                    error_2 = _a.sent();
                    console.log("bundleTransactions", bundleTransactions);
                    console.log("processedBTs", processedBTs);
                    throw { error: error_2, processedBTs: processedBTs, bundleTransactions: bundleTransactions };
                case 9: return [2 /*return*/];
            }
        });
    });
}
